<template>
  <div v-if="secciones.length">
    <div
      v-for="sec in secciones"
      :key="sec.key"
      :class="compact ? 'mb-3' : 'mb-4'"
    >
      <h6
        class="text-muted text-uppercase mb-2"
        :style="{ fontSize: compact ? '0.7rem' : '0.75rem', letterSpacing: '0.05em' }"
      >
        <i :class="['bi', sec.icon, 'me-1']"></i>{{ sec.title }}
      </h6>
      <ul class="list-group list-group-flush">
        <li
          v-for="(row, i) in sec.rows"
          :key="`${sec.key}-${i}`"
          class="list-group-item px-0 d-flex align-items-start gap-2"
          :class="compact ? 'py-1 border-0' : 'py-2'"
        >
          <span class="badge bg-light text-secondary mt-1" style="min-width:22px;">{{ i + 1 }}</span>
          <NutricionPlatoLink :texto="row.texto" :href="row.href || ''" />
        </li>
      </ul>
    </div>
  </div>
  <div v-else :class="compact ? 'small text-muted mb-0' : 'text-muted'">
    <i class="bi bi-info-circle me-1"></i>{{ emptyText }}
  </div>
</template>

<script>
import { computed } from 'vue';
import { menuSectionsWithRows } from '@/utils/nutricionMenus';
import NutricionPlatoLink from '@/components/NutricionPlatoLink.vue';

export default {
  name: 'NutricionMenuBloques',
  components: { NutricionPlatoLink },
  props: {
    semana: { type: Object, default: null },
    compact: { type: Boolean, default: false },
    emptyText: {
      type: String,
      default: 'No hay información de comidas disponible.',
    },
  },
  setup(props) {
    const secciones = computed(() => menuSectionsWithRows(props.semana));
    return { secciones };
  },
};
</script>
